export default __webpack_public_path__ + "static/media/mode-8.75ea9de7.svg";